export enum PageTitleKeys {
  PageTitle = 'page_title',
  LeaderboardPageTitle = 'leaderboard_page_title',
}

export enum RouteTitleKeys {
  Login = 'route_title_login',
}